
export default {
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: "default",
  data() {
    return{
      includeArr: ['IndexPage', 'aboutUs', 'productB']
    }
  }
}
